import type { FC, PropsWithChildren } from 'react';

import {
  StyledBannerContainer,
  StyledDescription,
  StyledTextContainer,
  StyledTextContent,
  StyledTitle,
} from './styles';
import type { BannerVariant } from './types';

type Props = PropsWithChildren<{
  title: string;
  description?: string;
  variant?: BannerVariant;
}>;

export const Banner: FC<Props> = ({ variant = 'info', title, description, children }) => (
  <StyledBannerContainer $variant={variant}>
    <StyledTextContainer>
      <StyledTextContent>
        <StyledTitle>{title}</StyledTitle>
        {description ? <StyledDescription>{description}</StyledDescription> : null}
      </StyledTextContent>

      {children}
    </StyledTextContainer>
  </StyledBannerContainer>
);
